export default __webpack_public_path__ + "static/media/EmptyNote.13e6746d.svg";